import { Button, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import ContactCalendarEventsList from '../../../components/Calendar/ContactCalendarEventsList/ContactCalendarEventsList';
import { ConsentInfo } from '../../../components/Contact/Consent/ConsentInfo';
import ContactDetails from '../../../components/Contact/ContactDetails/ContactDetails';
import ContactNotes from '../../../components/Contact/ContactNotes/ContactNotes';
import ContactOwners from '../../../components/Contact/ContactOwners/ContactOwners';
import ContactTags from '../../../components/Contact/ContactTags/ContactTags';
import DialogConfirmDeleteContact from '../../../components/Contact/DialogConfirmDeleteContact/DialogConfirmDeleteContact';
import {
    ContactDisplayAsideLayout,
    ContactDisplayLayout,
} from '../../../sic-lib/enums/ContactDisplayLayout';
import { GenericReducer, genericReducer } from '../../../sic-lib/reducers/genericReducer';
import { Contact } from '../../../sic-lib/types/Contact';
import AsideHeader from '../AsideHeader/AsideHeader';
import AsideTabButtons from '../AsideTabButtons/AsideTabButtons';

interface CDAsideState {
    view: ContactDisplayAsideLayout;
}

interface Props {
    cdDispatch: React.Dispatch<{ view: ContactDisplayLayout }>;
    contact: Contact;
}

export default function Aside({ cdDispatch, contact }: Props) {
    let history = useHistory();

    const [cdAsideState, cdAsideDispatch] = React.useReducer<GenericReducer<CDAsideState>>(
        genericReducer,
        {
            view: ContactDisplayAsideLayout.notes,
        },
    );

    const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);

    const handleDelete = () => {
        handleCloseDialog();
        history.replace('/');
    };

    const handleOpenDialog = (event: React.MouseEvent<HTMLButtonElement>, reason?: string) => {
        setConfirmDelete(true);
    };

    const handleCloseDialog = () => {
        setConfirmDelete(false);
    };

    // const [contentRef, setContentRef] = React.useState<HTMLIFrameElement | null>(null);
    // const mountNode = contentRef?.contentWindow?.document?.body;

    // const iframeURL = (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") ?
    //     `https://new.swsecure.test/loginsic/e506026e043c39541e8a235f68d3e280/${contactId}` :
    //     `https://6scentral.com/loginsic/e506026e043c39541e8a235f68d3e280/${contactId}`;

    // React.useEffect(() => {
    //     console.log('localhost?', window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1", iframeURL, contentRef);
    // }, [contentRef])

    //old
    // const iframeURL = (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") ?
    //     `https://new.swsecure.test/Main/?key=e506026e043c39541e8a235f68d3e280#/Lead/${contactId}/profile` :
    //     `https://6scentral.com/Main/?key=e506026e043c39541e8a235f68d3e280#/Lead/${contactId}/profile`

    return (
        <div className="contactDisplay__aside">
            <div className="cdAside__header">
                <AsideHeader contact={contact} cdDispatch={cdDispatch} />
            </div>
            <div className="cdAside__tabs">
                <AsideTabButtons
                    contact={contact}
                    view={cdAsideState.view}
                    cdAsideDispatch={cdAsideDispatch}
                />
            </div>
            <TransitionGroup component="div" className="cdAside__transitionWrapper">
                <CSSTransition key={cdAsideState.view} timeout={160} mountOnEnter>
                    <div className="cdAside__transition">
                        {cdAsideState.view === ContactDisplayAsideLayout.events && (
                            <ContactCalendarEventsList contact={contact} />
                        )}
                        {cdAsideState.view === ContactDisplayAsideLayout.notes && (
                            <ContactNotes contact={contact} />
                        )}
                        {cdAsideState.view === ContactDisplayAsideLayout.info && (
                            <Stack p={1} className="scrollWrapper--hideScrollbar" spacing={1}>
                                <ContactOwners contact={contact} />
                                <Typography variant="subtitle2" gutterBottom>
                                    Contact Info
                                </Typography>
                                <ContactDetails contact={contact} />
                                <Typography variant="subtitle2" gutterBottom>
                                    Contact Tags
                                </Typography>
                                <ContactTags contact={contact} />
                                <ConsentInfo contact={contact} />
                                <Box pt={4} display="flex" justifyContent="center">
                                    <Button
                                        color="error"
                                        onClick={handleOpenDialog}
                                        size="small"
                                        variant="outlined"
                                    >
                                        Delete Contact
                                    </Button>

                                    {confirmDelete && (
                                        <DialogConfirmDeleteContact
                                            isOpen={confirmDelete}
                                            contactId={contact.contactId}
                                            onDoneHandler={handleCloseDialog}
                                            onDeleteHandler={handleDelete}
                                        />
                                    )}
                                </Box>
                            </Stack>
                        )}
                        {/* {

                            (cdAsideState.view === ContactDisplayAsideLayout.engage) &&
                            <iframe ref={setContentRef} src={`https://new.swsecure.test/loginsic/e506026e043c39541e8a235f68d3e280/${contactId}`} className={classes.frame}>
                                {mountNode && createPortal(null, mountNode)}
                            </iframe>

                        } */}
                    </div>
                </CSSTransition>
            </TransitionGroup>
        </div>
    );
}
